import { Component, OnInit } from '@angular/core';
import { formatDate, Location } from '@angular/common';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';

/** Parse a `yyyy-MM-dd` string as a local date (no UTC day shift). */
function parseYmd(value: string | null | undefined): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || '');
  return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : null;
}

@Component({
    selector: 'app-depature-date',
    templateUrl: './depature-date.component.html',
    styleUrls: ['../picker.shared.css'],
    standalone: false
})
export class DepatureDateComponent implements OnInit {
  // bsInlineValue = new Date();
  displayMonths = 12;
  today=new Date();
  minDate:Date

  selected: Date | null = null;
  ngOnInit(): void {
    // Open on the date the traveller already has, so a re-pick is a one-tap tweak.
    const current = parseYmd(this.dataService.travelValueMobile.value);
    if (current && current.getTime() >= this.minDate.setHours(0, 0, 0, 0)) {
      this.selected = current;
    }
  }
  constructor(
    private router: Router,
    private dataService: DataService,
    private _location: Location
  ) {

    this.minDate = new Date();

  }

  cancel(): void {
    this._location.back();
  }

  onDateSelected(newDate: Date): void{
    this.selected = newDate;
    const date=formatDate(this.selected ,"yyyy-MM-dd","en-US");
    this.dataService.changeTravelMessage(date);
    this._location.back();
  }




}
